<ng-container>
	<a
		[attr.href]="item.url"
		(click)="itemClick($event)"
		*ngIf="!item.routerLink"
		(keydown.enter)="itemClick($event)"
		[attr.target]="item.target"
		[attr.tabindex]="0"
		[ngClass]="item.class"
		pRipple>
		<i [ngClass]="item.icon" class="layout-topbar-menuitem-icon"></i>
		<span class="layout-topbar-menuitem-text">{{ item.label }}</span>
		<i class="pi pi-fw pi-angle-down layout-topbar-submenu-toggler"></i>
	</a>
	<a
		(click)="itemClick($event)"
		*ngIf="item.routerLink"
		[routerLink]="item.routerLink"
		routerLinkActive="topbar-active-menuitem-routerlink"
		[routerLinkActiveOptions]="{ exact: true }"
		[attr.target]="item.target"
		[attr.tabindex]="0"
		[ngClass]="item.class"
		pRipple>
		<i [ngClass]="item.icon" class="layout-topbar-menuitem-icon"></i>
		<span class="layout-topbar-menuitem-text">{{ item.label }}</span>
		<i class="pi pi-fw pi-angle-down layout-topbar-submenu-toggler"></i>
	</a>
</ng-container>
